export {About as Page};

import messages from "../../messages/messages.js";
import {Helmet} from "react-helmet-async";
import {CheckBadgeIcon, MusicalNoteIcon, GlobeAltIcon, Cog6ToothIcon, ArrowTrendingUpIcon, RadioIcon} from "@heroicons/react/24/outline/index.js";
import {getSiteAbout} from "../../tenant/tenant-context.js";

const icons = {CheckBadgeIcon, MusicalNoteIcon, GlobeAltIcon, Cog6ToothIcon, ArrowTrendingUpIcon, RadioIcon};

function About() {

    const journey = getSiteAbout().map(item => ({
        ...item,
        icon: icons[item.icon],
    }));

    return (<>
        <section className="text-white">

            <Helmet>
                <title>{messages["META.NETWORK.TITLE"]}</title>
                <meta name="description" content={messages["META.NETWORK.DESC"]}/>
            </Helmet>

            <div className="text-center max-w-4xl mt-6 mb-14">
                <h1>About {messages['SITE.NAME']}</h1>
                <p>At {messages['DOMAIN']}, we're passionate about delivering the best in {messages['NAME']} music.
                    Our
                    platform hosts a vast collection of tracks, thoughtfully organized to match your mood and
                    preferences. We aim to provide an engaging and user-friendly experience for
                    all {messages['NAME']} enthusiasts. Discover new favorites, connect with fellow fans, and enjoy the dynamic rhythms</p>
            </div>

            <div className="flex flex-wrap max-w-xl">

                {journey.map((item, index) => {
                    const Icon = item.icon;
                    return (
                        <>
                            <div key={index} className="border border-border/60 bg-zinc-800 rounded-lg p-6">
                                <div className="flex items-center justify-between mb-2">
                                    <div className="flex items-center justify-between gap-2">
                                        <Icon className="w-6 h-6 text-green-500"/>
                                        <h3 className="text-lg mt-0 mb-0">{item.title}</h3>
                                    </div>
                                    <p className="m-0 text-sm text-gray-400">{item.date}</p>
                                </div>
                                <p className="mb-0 text-sm">{item.description}</p>
                            </div>
                            {index < journey.length - 1 && (
                                <div className="border-l-2 border-dashed border-zinc-500 mx-auto py-5"></div>
                            )}
                        </>
                    );
                })}

            </div>

        </section>
    </>);
}
